<template>
  <div class="login-wrapper">
    <div class="head">
      <div class="head-img"></div>
      <div class="text">报名成功</div>
      <div class="price">
        <div class="icon">￥</div>
        <div class="price-text">0</div>
      </div>
    </div>
    <div class="btn" @click="downClick">下载学习APP</div>
    <div class="share-btn btn" @click="shareClick">邀请返现</div>
    <!-- <div class="share-text">推荐有礼规则请咨询辅导老师</div> -->
  </div>
</template>
<script>
import { ERROR_OK } from "../../request/http"
import wx from "weixin-js-sdk"
import { getAppId, getSdk } from "../../request/api/study"
export default {
  data () {
    return {
      imgurl: ""
    }
  },
  created () {
    this.imgurl = this.getCookie("imgUrl")
    this.openid = this.$route.query.openid
    this.channelId = this.$route.query.channelId
    this.distributorId = this.$route.query.distributorId
    this.distributorType = this.$route.query.distributorType
    if (
      navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
      "micromessenger"
    ) {
      this.getAppIdInfo()
    }
  },
  methods: {
    getCookie (cname) {
      let name = cname + "="
      let ca = document.cookie.split(";")
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) === " ") c = c.substring(1)
        if (c.indexOf(name) !== -1) {
          return c.substring(name.length, c.length)
        }
      }
      return ""
    },
    downClick () {
      window.location.href =
        "https://a.app.qq.com/o/simple.jsp?pkgname=com.edu.jimu"
    },
    shareClick () {
      this.$router.push({
        name: "recommend",
        query: {
          distributorId: this.distributorId,
          distributorType: 2,
          openid: this.openid,
          channelId: this.channelId,
          isBind: 1
        }
      })
    },
    async getAppIdInfo () {
      let { code, data } = await getAppId({})
      if (code === ERROR_OK) {
        console.log(data)
        const appId = data.appId
        let timestamp = Math.floor(+new Date() / 1000)
        let nonceStr = timestamp + "1"
        let url = window.location.href.split("#")[0]
        let { code: sdkCode, data: sdkData } = await getSdk({
          timestamp,
          nonceStr,
          url,
          appId
        })
        if (sdkCode === ERROR_OK) {
          const signature = sdkData.signature
          await wx.config({
            debug: false,
            appId,
            timestamp,
            nonceStr,
            signature,
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"]
          })
          wx.error(res => {
            console.log(res)
          })
          wx.ready(() => {
            this.updateAppMessageShareData()
            this.updateTimelineShareData()
          })
        }
      }
    },
    updateAppMessageShareData () {
      let title =
        "你的朋友送你一周趣味思维AI课，课程太有趣了，我家宝贝正在上！"
      if (this.channelId == 2) {
        title = "你的朋友送你双周趣味思维AI课，课程太有趣了，我家宝贝正在上！"
      }
      let desc = "做好思维启蒙，让孩子爱学习，会思考"
      let imgUrl =
        "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2009/H6r2fkdwK4hHCjA5Ts6yTYPCEcfwcG5R.png"
      if (this.channelId == 2) {
        imgUrl =
          "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2009/pd6yjBzne4BNSK8BW8ZDFrGCa4HTXzZz.png"
      }
      let link = `http://jimuaike.com/wap/#/exchange?openid=${this.openid}&channelId=${this.channelId}`
      wx.updateAppMessageShareData({
        title,
        desc,
        link,
        imgUrl,
        success () {
          console.log("分享成功")
        }
      })
    },
    updateTimelineShareData () {
      let title =
        "你的朋友送你一周趣味思维AI课，课程太有趣了，我家宝贝正在上！"
      if (this.channelId == 2) {
        title = "你的朋友送你双周趣味思维AI课，课程太有趣了，我家宝贝正在上！"
      }
      let desc = "做好思维启蒙，让孩子爱学习，会思考"
      let imgUrl =
        "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2009/H6r2fkdwK4hHCjA5Ts6yTYPCEcfwcG5R.png"
      if (this.channelId == 2) {
        imgUrl =
          "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2009/pd6yjBzne4BNSK8BW8ZDFrGCa4HTXzZz.png"
      }
      let link = `http://jimuaike.com/wap/#/exchange?openid=${this.openid}&channelId=${this.channelId}`
      wx.updateTimelineShareData({
        title,
        desc,
        link,
        imgUrl,
        success () {
          console.log("分享成功")
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
.login-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 0;
  bottom: 0;
  right: 0;
  background: #f4f4f4;
  .head {
    padding-top: 200px;
    .head-img {
      width: 160px;
      height: 155px;
      background: url("./dui.png") no-repeat;
      background-size: cover;
    }
    .text {
      margin-top: 24px;
      font-size: 34px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      line-height: 48px;
    }
    .price {
      display: flex;
      align-items: baseline;
      justify-content: center;
      margin-top: 4px;
      font-size: 30px;
      font-family: SFProDisplay-Regular, SFProDisplay;
      font-weight: 400;
      color: #ff5330;
      .icon {
        line-height: 36px;
      }
      .price-text {
        font-size: 48px;
        line-height: 58px;
      }
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 60px 40px;
    margin-top: 40px;
    background: #ffffff;
    .title {
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      line-height: 45px;
    }
    .wechat-img {
      width: 300px;
      height: 300px;
      margin-top: 30px;
      .img {
        display: block;
        width: 300px;
        height: 300px;
      }
    }
    .text {
      margin-top: 24px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 37px;
    }
  }
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 560px;
    height: 90px;
    margin-top: 406px;
    background: #0093dd;
    border-radius: 45px;
    font-size: 34px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
  .share-btn {
    margin-top: 40px;
    border-radius: 45px;
    border: 1px solid #0093dd;
    background: transparent;
    color: #0093dd;
  }
  .share-text {
    margin-top: 24px;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 37px;
  }
}
</style>
